<template>
    <div class="user-statistics-warp">
        <monitorTitle nub="9" :text="title" width="auto" />

        <div class="box">
            <div id="user-statistics" style="width: 550px;height:230px;"></div>
        </div>
    </div>
</template>

<script>
    const echarts = require('echarts');
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                list: [],
                title: '',
                unit: '',
            }
        },
        watch: {
            Data(n) {
                this.getData()
            },
            list() {
                this.init()
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                let list = []
                if (this.Data && this.Data.data9) {
                    this.title = this.Data.data9.title1 || this.title1
                    this.unit = this.Data.data9.unit1 || this.unit
                    list = this.Data.data9.items1 ? this.Data.data9.items1 : []
                }
                this.list = list

                // this.list = [{
                //         x: '3-10',
                //         y1: 234,
                //         y2: 12
                //     },
                //     {
                //         x: '3-11',
                //         y1: 193,
                //         y2: 90
                //     },
                //     {
                //         x: '3-12',
                //         y1: 213,
                //         y2: 40
                //     },
                //     {
                //         x: '3-13',
                //         y1: 220,
                //         y2: 113
                //     },
                //     {
                //         x: '3-14',
                //         y1: 322,
                //         y2: 156
                //     },
                //     {
                //         x: '3-15',
                //         y1: 190,
                //         y2: 66
                //     },
                //     {
                //         x: '3-16',
                //         y1: 184,
                //         y2: 123
                //     },
                //     {
                //         x: '3-17',
                //         y1: 212,
                //         y2: 87
                //     }
                // ]
            },
            init() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('user-statistics'));

                let xAxisData = []
                let seriesData = []
                let seriesData2 = []

                this.list.forEach((i, k) => {
                    xAxisData.push(i.x || '')
                    seriesData.push(i.y1 || 0)
                    seriesData2.push(i.y2 || 0)
                })

                // 指定图表的配置项和数据
                let option = {
                    title: {
                        subtext: this.unit,
                        subtextStyle: {
                            //文字颜色
                            color: '#74a0bf',
                            //字体大小
                            fontSize: 12
                        }
                    },
                    color: ['#17CAFC', '#17FCC3'],
                    legend: {
                        data: ['最高', '最低'],
                        top: 20,
                        left: 0,
                        textStyle: {
                            color: '#74A0BF',
                            fontStyle: 12,
                        },
                        itemGap: 70,
                    },
                    grid: {
                        x: "6%", //x 偏移量
                        width: "92%", // 宽度
                        height: "56%" // 高度
                    },
                    dataZoom: [ //给x轴设置滚动条
                        {
                            start: 0, //默认为0
                            end: 100 - 1500 / 31, //默认为100
                            type: 'slider',
                            // 显示滚动条
                            show: false,
                            xAxisIndex: [0],
                            handleSize: 0, //滑动条的 左右2个滑动条的大小
                            height: 4, //组件高度
                            left: '10%', //左边的距离
                            right: '10%', //右边的距离
                            bottom: 18, //右边的距离
                            borderColor: "#000",
                            fillerColor: '#01b3e4',
                            borderRadius: 5,
                            backgroundColor: '#33384b', //两边未选中的滑动条区域的颜色
                            showDataShadow: false, //是否显示数据阴影 默认auto
                            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
                            realtime: true, //是否实时更新
                            filterMode: 'filter',
                        },
                        // 下面这个属性是里面拖到
                        {
                            type: 'inside',
                            show: true,
                            xAxisIndex: [0],
                            start: 0, //默认为1
                            end: 100 - 1500 / 31, //默认为100
                        },
                    ],
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#01b3e4'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: xAxisData,
                        // 刻度
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf', //左边线的颜色
                                width: '1' //坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                // 坐标值得具体的颜色
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        // 是否是脱离 0 值比例，true：自适应
                        scale: false,
                        // 分割刻度
                        minInterval: 20,
                        // 坐标轴的分割段数
                        splitNumber: 4,
                        max: function(value) { //取最大值向上取整为最大刻度
                            return Math.ceil(value.max + 20)
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf',
                                width: '1'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        },
                        splitLine: {
                            show: true, //X网格线
                            lineStyle: { //x网格线
                                color: '#002d37'
                            }
                        }
                    },
                    series: [{
                            name: '最高',
                            data: seriesData,
                            type: 'line',
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(13, 110, 140,1)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(6, 43, 58,0.5)'
                                }])
                            },
                            lineStyle: {
                                color: '#17cafc',
                                width: 3
                            },
                            // 圆弧
                            smooth: true,
                            // 拐点 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
                            symbol: 'circle',
                            symbolSize: 9,
                            itemStyle: {
                                borderWidth: 1,
                                borderColor: '#17cafc',
                                // color: '#ffffff'
                            },
                            // 文本标签
                            // label: {
                            //     show: true,
                            //     position: 'top',
                            //     align: 'left',
                            //     fontSize: 12,
                            //     color: '#ffffff'
                            // },
                        },
                        {
                            name: '最低',
                            data: seriesData2,
                            type: 'line',
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(2, 66, 65)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(1, 46, 54,0.5)'
                                }])
                            },
                            lineStyle: {
                                color: '#0ffac6',
                                width: 3
                            },
                            // 圆弧
                            smooth: true,
                            // 拐点
                            symbol: 'circle',
                            symbolSize: 9,
                            itemStyle: {
                                borderWidth: 1,
                                borderColor: '#17cafc',
                                // color: '#ffffff'
                            },
                            // 文本标签
                            // label: {
                            //     show: true,
                            //     position: 'top',
                            //     align: 'left',
                            //     fontSize: 12,
                            //     color: '#ffffff'
                            // },
                        }
                    ],
                    showAllSymbol: 0
                };
                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="less" scoped>
    .user-statistics-warp {
        width: 597px;

        .box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            height: 238px;
            background-image: url("/static/images/home/chart-bg-2.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            #user-statistics {
                margin: 0 auto;
            }
        }
    }
</style>
